import { render, staticRenderFns } from "./refund_confirm.vue?vue&type=template&id=0aa2db60&scoped=true"
import script from "./refund_confirm.vue?vue&type=script&lang=js"
export * from "./refund_confirm.vue?vue&type=script&lang=js"
import style0 from "./refund_confirm.vue?vue&type=style&index=0&id=0aa2db60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2db60",
  null
  
)

export default component.exports